// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"1d6cfb11","267":"e8390c67","380":"e8390c67","716":"e8390c67"}[chunkId] + ".chunk.css";
};